<template>
  <div id="becomeHost">
    <div id="header">
      <div class="header-container">
        <img class="header-img" src="../../images/devenir-hote.webp" alt="Devenir partenaire" />
        <div class="text-overlay">
          <h2>Devenir hôte</h2>
          <p>Valorisez votre lieu auprès de voyageurs en quête d’hébergements uniques, élégants et durables</p>
        </div>
      </div>
    </div>
    <section class="intro-block">
      <p class="intro-text">
        Vous êtes <strong>propriétaire ou gestionnaire d’un hôtel</strong>, d’une
        <strong>maison d’hôtes</strong> ou d’un <strong>lieu d’hébergement au charme singulier</strong>
        et à l’ancrage durable ? <br />
        Hortense sélectionne avec soin des établissements indépendants qui conjuguent
        <strong>esthétique</strong>, <strong>authenticité</strong> et
        <strong>conscience écologique</strong>. <br />
        En rejoignant notre sélection, vous valorisez votre engagement et accédez à une clientèle
        en quête de séjours porteurs de sens.
      </p>
      <button class="hortense-btn-primary join-btn" @click="openModal">
        JE REJOINS LA SÉLECTION HORTENSE
      </button>
      <div
  v-if="isModalOpen"
  class="modal-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="contactTitle"
  @click.self="closeModal"
>
  <div class="modal-shell">
    <button class="modal-close" @click="closeModal" aria-label="Fermer la fenêtre">×</button>
    <div class="modal-head">
      <p class="kicker">Vous partagez nos valeurs&nbsp;?</p>
      <h2 id="contactTitle" class="title">Parlons–en</h2>
      <p class="subtitle">
        Complétez le formulaire ci-dessous, nous prendrons contact avec vous dans les meilleurs délais
        pour en savoir plus sur votre établissement et vous présenter notre processus de sélection.
      </p>
    </div>

    <div class="form-card">
      <form ref="form" @submit.prevent="handleSubmit" action="https://formspree.io/f/xqknyled" method="POST" novalidate>
        <div class="form-grid">
          <div class="form-item">
            <label for="first_name">Prénom <span class="req">*</span></label>
            <input id="first_name" name="first_name" type="text" v-model="first_name" required />
          </div>
          <div class="form-item">
            <label for="last_name">Nom <span class="req">*</span></label>
            <input id="last_name" name="last_name" type="text" v-model="last_name" required />
          </div>
          <div class="form-item">
            <label for="email">Email <span class="req">*</span></label>
            <input id="email" name="email" type="email" v-model="email" required />
          </div>
          <div class="form-item">
            <label for="telephone">Numéro de téléphone <span class="req">*</span></label>
            <input id="telephone" name="telephone" type="text" v-model="phone" required />
          </div>
          <div class="form-item">
            <label for="hebergement">Nom de l'établissement <span class="req">*</span></label>
            <input id="hebergement" name="hebergement" type="text" v-model="name" required />
          </div>
          <div class="form-item">
            <label for="poste">Poste occupé au sein de l’établissement</label>
            <input id="poste" name="poste" type="text" v-model="post" />
          </div>
          <div class="form-item">
            <label for="address">Adresse de l’établissement</label>
            <input id="address" name="address" type="text" v-model="address" />
          </div>
          <div class="form-item">
            <label for="website">Site web de l’établissement</label>
            <input id="website" name="website" type="text" v-model="website" />
          </div>
          <div class="form-item">
            <label for="message">Message <span class="req">*</span></label>
            <textarea id="message" name="message" rows="5" v-model="message" required></textarea>
          </div>

          <p class="required-note">* Champs obligatoires</p>

          <div class="cta-wrap">
            <button type="submit" class="hortense-btn-primary contact-submit">
              JE VALIDE MA DEMANDE
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    </section>
    <section id="whyJoin">
    <h2 class="section-title" style="font: normal normal normal 24px/29px Merriweather;">Pourquoi rejoindre</h2>
    <h2 style="font: normal normal normal 40px/29px Merriweather; text-align: center;">Hortense&nbsp;?</h2>
    <div class="cards-container mt-2">
      <article class="card">
        <img src="../../images/aa.webp" alt="Clientèle ciblée et affinitaire" class="card-img" />
        <div class="card-body">
          <h3 class="card-title">UNE CLIENTÈLE CIBLÉE ET AFFINITAIRE</h3>
          <p class="card-text">
            Hortense est constituée de voyageurs exigeants, à la recherche
            d’expériences durables et raffinées. Nous vous offrons une vitrine
            qualitative et ciblée, bien au-delà d’un simple site de réservation.
          </p>
        </div>
      </article>
      <article class="card">
        <img src="../../images/bb.webp" alt="Positionnement haut de gamme et engagé" class="card-img" />
        <div class="card-body">
          <h3 class="card-title">UN POSITIONNEMENT HAUT DE GAMME ET ENGAGÉ</h3>
          <p class="card-text">
            Nous mettons en lumière des lieux choisis avec soin, qui reflètent des valeurs
            fortes : beautés des lieux, accueil sincère, respect de l’environnement, ancrage local.
          </p>
        </div>
      </article>
      <article class="card">
        <img src="../../images/cc.webp" alt="Accompagnement personnalisé" class="card-img" />
        <div class="card-body">
          <h3 class="card-title">UN ACCOMPAGNEMENT PERSONNALISÉ</h3>
          <p class="card-text">
            Avec le programme Evergreen, bénéficiez d’un soutien opérationnel et financier
            dans votre transition écologique : diagnostic, conseils sur les pratiques vertes,
            aides à l’investissement.
          </p>
        </div>
      </article>
      <article class="card">
        <img src="../../images/dd.webp" alt="Outils exclusifs pour valoriser votre engagement" class="card-img" />
        <div class="card-body">
          <h3 class="card-title">DES OUTILS EXCLUSIFS POUR VALORISER VOTRE ENGAGEMENT</h3>
          <p class="card-text">
            Notre outil d’évaluation mesure de manière transparente votre niveau
            d’engagement écoresponsable et distingue les hébergements les plus vertueux
            pour mieux les faire rayonner auprès de notre communauté.
          </p>
        </div>
      </article>
    </div>
  </section>
    <section id="contactSection" class="contact">
  <div class="contact-header">
    <p class="contact-kicker" style="font: normal normal normal 24px/29px Merriweather !important;">Vous partagez nos valeurs&nbsp;?</p>
    <h2 class="contact-title" style="font: normal normal normal 40px/29px Merriweather !important;">Parlons–en</h2>
    <p class="contact-subtitle" style="font: normal normal normal 16px/24px Raleway;">
      Complétez le formulaire ci-dessous, nous prendrons contact avec vous dans les meilleurs délais
      pour en savoir plus sur votre établissement et vous présenter notre processus de sélection.
    </p>
  </div>
  <div class="form-card">
    <form ref="form" @submit.prevent="handleSubmit" action="https://formspree.io/f/xqknyled" method="POST" novalidate>
      <div class="form-grid">
        <div class="form-item">
          <label for="first_name">Prénom <span class="req">*</span></label>
          <input id="first_name" name="first_name" type="text" v-model="first_name" required />
        </div>
        <div class="form-item">
          <label for="last_name">Nom <span class="req">*</span></label>
          <input id="last_name" name="last_name" type="text" v-model="last_name" required />
        </div>
        <div class="form-item">
          <label for="email">Email <span class="req">*</span></label>
          <input id="email" name="email" type="email" v-model="email" required />
        </div>
        <div class="form-item">
          <label for="telephone">Numéro de téléphone <span class="req">*</span></label>
          <input id="telephone" name="telephone" type="text" v-model="phone" required />
        </div>
        <div class="form-item">
          <label for="hebergement">Nom de l'établissement <span class="req">*</span></label>
          <input id="hebergement" name="hebergement" type="text" v-model="name" required />
        </div>
        <div class="form-item">
          <label for="poste">Poste occupé au sein de l’établissement</label>
          <input id="poste" name="poste" type="text" v-model="post" />
        </div>
        <div class="form-item">
          <label for="address">Adresse de l’établissement</label>
          <input id="address" name="address" type="text" v-model="address" />
        </div>
        <div class="form-item">
          <label for="website">Site web de l’établissement</label>
          <input id="website" name="website" type="text" v-model="website" />
        </div>
        <div class="form-item">
          <label for="message">Message <span class="req">*</span></label>
          <textarea id="message" name="message" rows="5" v-model="message" required></textarea>
        </div>
        <p class="required-note">* Champs obligatoires</p>
        <div class="cta-wrap">
          <button type="submit" class="hortense-btn-primary contact-submit">JE VALIDE MA DEMANDE</button>
        </div>
        <p class="join-selection-note">
          Si vous souhaitez rejoindre notre sélection,
          <a href="/pages/contact/" class="join-selection-link">contactez-nous ici</a>
        </p>
      </div>
    </form>
  </div>
</section>
<MoreAbout></MoreAbout>
  <section id="instaShowcase" class="insta">
    <div class="insta-head">
      <p class="kicker" style="font: normal normal normal 24px/29px Merriweather;">Ils nous ont fait</p>
      <h2 class="title" style="font: normal normal normal 40px/29px Merriweather;" >Confiance</h2>
      <p class="subtitle">Nos partenaires engagés, en images…</p>
    </div>

    <div class="insta-frame"  @click="openShowPhoto()">
      <img src="../../images/devenir-hote-instagram.webp" alt="Nos partenaires en images" />
    </div>

    <div class="cta-wrap">
      <a href="https://www.instagram.com/hortense.green_/" target="_blank" rel="noopener" class="hortense-btn-primary insta-btn">
        VOIR PLUS SUR INSTAGRAM
      </a>
    </div>
  </section>
  </div>
</template>

<script>
import MoreAbout from './MoreAbout.vue';

export default {
    name: 'becomeHost',
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            post: '',
            name: '',
            address: '',
            website: '',
            message: '',
            isModalOpen: false,
        };
    },
    methods: {
        async hashEmail(email) {
            if (email && email !== '') {
                const encoder = new TextEncoder();
                const data = encoder.encode(email);
                const hash = await crypto.subtle.digest('SHA-256', data);
                const hashArray = Array.from(new Uint8Array(hash));
                return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
            }
            else {
                return "";
            }
        },
        openModal() {
      this.isModalOpen = true;
      document.documentElement.classList.add('no-scroll');
    },
    openShowPhoto() {
      window.location.href = 'https://www.instagram.com/hortense.green_/';
    },
    closeModal() {
      this.isModalOpen = false;
      document.documentElement.classList.remove('no-scroll');
    },
    onKeydown(e) {
      if (e.key === 'Escape' && this.isModalOpen) this.closeModal();
    },
        async handleSubmit() {
            const hashedEmail = await this.hashEmail(this.email || '');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_submit',
                user: {
                    email: hashedEmail,
                },
            });
            this.$refs.form.submit();
        },
    },
    components: { MoreAbout },
    mounted() { window.addEventListener('keydown', this.onKeydown); },
  beforeDestroy() { window.removeEventListener('keydown', this.onKeydown); },
};
</script>

<style lang="scss" scoped>
#becomeHost {
  display: block;
  #header {
  margin-top: 2%;
}

.header-container {
  position: relative;
  display: flex;
  align-items: center; 
  justify-content: center; 
  height: 500px;
}

.header-img {
  width: 100%;
  height: 100%;
  object-fit: cover;  
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(.6);
}

.text-overlay {
  position: absolute;  
  text-align: center;
  color: white;  
  z-index: 1;  
}

.text-overlay h2 {
  font: normal normal normal 40px/50px Merriweather;
}

.text-overlay p {
  font: italic normal 300 24px/31px Merriweather;
}

  .form-container {
    border: 1px solid #CCC;
    margin: 3% 30%;
    padding: 2%;
    margin-bottom: 0px !important;
  }

  .border-input {
    border: none;
    border-bottom: 1px solid #ccc;
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 2%;
  }

  .footer-container-become {
    margin: 1% 28%;
    padding: 2%;
    margin-top: 0px !important;
  }
  .mobile-img{
    width: 100%;
    height: 60%;
  }

  .btn-submit-become {
    margin: auto 23%;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    #header {
      margin-top: 25%;
      padding: 2%;

      h2 {
        font-size: 24px;
      }
    }
    .form-container {
      margin: 3% 5%;
      padding: 3%;
    }

    .footer-container-become {
      margin: 1% 5%;
    }
    .mobile-img{
    width: 100%;
    height: 27vh;
  }
  }

}
#becomeHost {
  font-family: 'Raleway', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
}

.header-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.intro-block {
  background: #e8f0ea;
  padding: 2.25rem 1.25rem;
  text-align: center;
  margin: 0;

  .intro-text {
    margin: 0 auto 1.25rem;
    max-width: 980px;
    line-height: 1.75;
    font-size: 1rem;
    color: #1f1f1f;
    font: normal normal normal 15px/24px Raleway !important;
  }

  .intro-text strong {
    font-weight: 700; 
  }

  .join-btn {
    display: inline-block;
    margin: 0 auto;
    padding: 0.85rem 1.75rem;
    font-weight: 700; 
  }
}

.form-container {
  border: 1px solid #CCC;
  margin: 3% 30%;
  padding: 2%;
}

.footer-container-become {
  margin: 2% 28%;
  padding: 2%;
}

@media (max-width: 768px) {
  .intro-block {
    padding: 1.5rem 1rem;

    .intro-text {
      max-width: 100%;
      font-size: 0.98rem;
      line-height: 1.7;
    }
  }

  .form-container {
    margin: 5% 5%;
    padding: 3%;
  }

  .footer-container-become {
    margin: 5% 5%;
  }
}
#whyJoin {
  font-family: 'Raleway', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  padding: 3rem 1.25rem;

  .section-title {
    text-align: center;
    font-weight: 700;
    font-size: 2rem;
    line-height: 1.2;
    margin: 0 0 2rem;
    span { color: #000; }
  }

  .cards-container {
    display: flex;
    gap: 1.5rem;
    overflow-x: auto;           
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    padding-bottom: 0.5rem;
  }

  .card {
    flex: 0 0 280px;             
    scroll-snap-align: start;
    display: flex;
    flex-direction: column;
    background: transparent;   
    border: none;
    box-shadow: none;
    border-radius: 0;
  }

  .card-img {
    width: 100%;
    height: 55% !important;
    display: block;
  }

  .card-body {
    padding-top: 0.75rem;
    text-align: left;
  }

  .card-title {
    letter-spacing: 0.02em;
    margin: 0 0 0.5rem;
    text-transform: uppercase;
    color: #000;
    font: normal normal bold 16px/19px Raleway !important;
  }

  .card-text {
    line-height: 1.55;
    color: #333;
    font: normal normal normal 15px/24px Raleway !important;
    margin: 0;
  }

  .card:nth-child(even)   { transform: translateY(48px); }
  .card:nth-child(odd)    { transform: translateY(0); }

  @media (min-width: 992px) {
    .cards-container {
      overflow-x: visible;
      justify-content: center;
      gap: 2rem;
    }
    .card        { flex: 0 0 22%; }
    .card-img    { height: 50%; }
    .card:nth-child(even) { transform: translateY(60px); }
  }

  @media (max-width: 360px) {
    .card       { flex-basis: 240px; }
    .card-img   { height: 160px; }
    .card:nth-child(even) { transform: translateY(36px); }
  }
}

.contact {
  font-family: 'Raleway', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  padding: 2.5rem 1rem 3.5rem;

  .contact-header {
    text-align: center;
    max-width: 900px;
    margin: 0 auto 1.75rem;
  }

  .contact-kicker {
    font-weight: 600;
    font-size: 1.25rem;
    margin: 0 0 .25rem;
  }

  .contact-title {
    font-weight: 800;
    font-size: 2.2rem;
    line-height: 1.15;
    margin: 0 0 .9rem;
  }

  .contact-subtitle {
    color: #3d3d3d;
    font-size: .98rem;
    line-height: 1.6;
    margin: 0 auto;
    max-width: 62ch;
  }

  .form-card {
    background: #fff;
    border: 1px solid #ececec;
    box-shadow: 0 6px 18px rgba(0,0,0,.06);
    border-radius: 6px;
    max-width: 850px;
    margin: 1.25rem auto 0;
    padding: 1.25rem;

    @media (min-width: 768px) {
      padding: 2rem 2rem 2.25rem;
    }
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .form-item {
    display: flex;
    flex-direction: column;
    gap: .4rem;

    label {
      font-size: .95rem;
      color: #1f1f1f;
    }

    .req { color: #c43d2f; }
  }

  input[type="text"],
  input[type="email"],
  textarea {
    width: 100%;
    padding: .7rem .75rem;
    border: 1.5px solid #3f6b5c;  
    border-radius: 2px;
    background: #fff;
    font-size: .98rem;
    outline: none;
  }

  input:focus,
  textarea:focus {
    border-color: #2f5a4d;
    box-shadow: 0 0 0 2px rgba(47, 90, 77, 0.08);
  }

  textarea { resize: vertical; }

  .required-note {
    margin: .25rem 0 0;
    font-size: .85rem;
    color: #6b6b6b;
  }

  .cta-wrap {
    display: flex;
    justify-content: center;
    margin-top: 1.25rem;
  }

  .contact-submit {
    padding: .9rem 1.6rem;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: none;  
  }

  @media (min-width: 992px) {
    .contact-title   { font-size: 3rem; }
    .contact-kicker  { font-size: 1.35rem; }
    .contact-subtitle{ font-size: 1rem; }
  }
}

.insta {
  font-family: 'Raleway';
  padding: 2.5rem 1rem 3rem;

  .insta-head {
    text-align: center;
    margin-bottom: 1.25rem;

    .kicker   { font-weight: 600; font-size: 1.1rem; margin: 0; }
    .title    { font-weight: 800; font-size: 2.1rem; line-height: 1.15; margin: .25rem 0 .5rem; }
    .subtitle { color: #606060; font-size: .98rem; margin: 0; }
  }

  .insta-frame {
    max-width: 1120px;     
    margin: 0 auto 1.25rem;
    padding: 0 0;           

    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
      border: none;
      box-shadow: none;
      border-radius: 0;
    }
  }

  .cta-wrap {
    display: flex;
    justify-content: center;
  }

  .insta-btn {
    padding: .85rem 1.6rem;
    font-weight: 700;
    letter-spacing: .02em;
    text-align: center;
  }

  @media (min-width: 992px) {
    .insta { padding: 3rem 2rem 3.5rem; }
    .insta-head .title { font-size: 2.6rem; }
    .insta-head .subtitle { font-size: 1rem; }
  }
}

#becomeHost {
  font-family: 'Raleway';
}

#becomeHost button,
#becomeHost input,
#becomeHost textarea,
#becomeHost select {
  font: inherit;
}

#becomeHost * { font-family: inherit; }
/* scroll lock */
:global(html.no-scroll) { overflow: hidden; }

/* Overlay */
.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.55);
  display: grid; place-items: center;
  z-index: 9999;
  padding: 1rem;
  font-family: 'Raleway', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
}

/* Shell (white panel) */
.modal-shell {
  position: relative;
  width: 100%;
  max-width: 980px;
  max-height: 90vh;
  overflow: auto;
  background: #fff;
  border-radius: 6px;                /* subtle like mock */
  box-shadow: 0 24px 60px rgba(0,0,0,.25);
  padding: 1.25rem;

  @media (min-width: 992px) { padding: 2rem 2rem 2.25rem; }
}

/* Close button (top-right “x”) */
.modal-close {
  position: absolute; top: .85rem; right: .85rem;
  width: 28px; height: 28px;
  border: none; background: transparent; color: #2b2b2b;
  font-size: 22px; line-height: 1; cursor: pointer;
}

.modal-head { text-align: center; margin-bottom: 1.25rem; }
.modal-head .kicker { font-weight: 600; font-size: 1.1rem; margin: 0; }
.modal-head .title  { font-weight: 800; font-size: 2.2rem; margin: .25rem 0 .6rem; line-height: 1.15; }
.modal-head .subtitle { color: #3d3d3d; font-size: .98rem; line-height: 1.6; margin: 0; }

.form-card {
  background: #fff;
  border: 1px solid #e9e9e9;
  box-shadow: 0 6px 18px rgba(0,0,0,.06);
  border-radius: 6px;
  padding: 1.25rem;

  @media (min-width: 768px) { padding: 1.75rem; }
}

.form-grid { display: grid; grid-template-columns: 1fr; gap: 1rem; }

.form-item { display: flex; flex-direction: column; gap: .4rem; }
.form-item label { font-size: .95rem; color: #1f1f1f; }
.req { color: #c43d2f; }

input[type="text"], input[type="email"], textarea {
  width: 100%; padding: .7rem .75rem;
  border: 1.5px solid #3f6b5c; border-radius: 2px; background: #fff;
  font-size: .98rem; outline: none;
}
input:focus, textarea:focus { border-color: #2f5a4d; box-shadow: 0 0 0 2px rgba(47,90,77,.08); }
textarea { resize: vertical; }

.required-note { margin: .25rem 0 0; font-size: .85rem; color: #6b6b6b; }
.cta-wrap { display: flex; justify-content: center; margin-top: 1.25rem; }
.contact-submit { padding: .9rem 1.6rem; font-weight: 700; }

@media (min-width: 992px) {
  .modal-head .title { font-size: 2.8rem; }
  .modal-head .subtitle { font-size: 1rem; }
}

@media (max-width: 768px) {
  #header { margin-top: 0; }
  .header-img {
    width: 100%;
    height: 55vh;        
    max-height: 65vh;
    object-fit: cover;
    display: block;
  }
}
@media (max-width: 768px) {
  #whyJoin .cards-container {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 16px 12px;
    gap: 12px;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x proximity;
    touch-action: pan-x;          
    overscroll-behavior-x: contain;
  }

  #whyJoin .card { flex: 0 0 82vw; }  
  #whyJoin .card-img {
    height: 48vw;                     
    object-fit: cover;
  }
}
@media (max-width: 768px) {
  .contact { padding: 24px 12px 40px; }
  .contact .form-card {
    margin: 16px auto 0;
    padding: 16px;
    max-width: 100%;
    border-radius: 8px;
  }
}
@media (max-width: 768px) {
  img { max-width: 100%; height: auto; }
}


</style>